// Fetch Invoice Companies
export const FETCH_INVOICE_COMPANIES = "FETCH_INVOICE_COMPANIES"
export const FETCH_INVOICE_COMPANIES_SUCCESS = "FETCH_INVOICE_COMPANIES_SUCCESS"
export const FETCH_INVOICE_COMPANIES_FAIL = "FETCH_INVOICE_COMPANIES_FAIL"

// Create Invoice Company
export const CREATE_INVOICE_COMPANY = "CREATE_INVOICE_COMPANY"
export const CREATE_INVOICE_COMPANY_SUCCESS = "CREATE_INVOICE_COMPANY_SUCCESS"
export const CREATE_INVOICE_COMPANY_FAIL = "CREATE_INVOICE_COMPANY_FAIL"

// Update Invoice Company
export const UPDATE_INVOICE_COMPANY = "UPDATE_INVOICE_COMPANY"
export const UPDATE_INVOICE_COMPANY_SUCCESS = "UPDATE_INVOICE_COMPANY_SUCCESS"
export const UPDATE_INVOICE_COMPANY_FAIL = "UPDATE_INVOICE_COMPANY_FAIL"

// Delete Invoice Company
export const DELETE_INVOICE_COMPANY = "DELETE_INVOICE_COMPANY"
export const DELETE_INVOICE_COMPANY_SUCCESS = "DELETE_INVOICE_COMPANY_SUCCESS"
export const DELETE_INVOICE_COMPANY_FAIL = "DELETE_INVOICE_COMPANY_FAIL"

// Test Connections
export const TEST_INVOICE_COMPANY_AADE = "TEST_INVOICE_COMPANY_AADE"
export const TEST_INVOICE_COMPANY_AADE_SUCCESS = "TEST_INVOICE_COMPANY_AADE_SUCCESS"
export const TEST_INVOICE_COMPANY_AADE_FAIL = "TEST_INVOICE_COMPANY_AADE_FAIL"

export const TEST_INVOICE_COMPANY_EPSILON = "TEST_INVOICE_COMPANY_EPSILON"
export const TEST_INVOICE_COMPANY_EPSILON_SUCCESS = "TEST_INVOICE_COMPANY_EPSILON_SUCCESS"
export const TEST_INVOICE_COMPANY_EPSILON_FAIL = "TEST_INVOICE_COMPANY_EPSILON_FAIL"

// Clear Error
export const CLEAR_INVOICE_COMPANY_ERROR = "CLEAR_INVOICE_COMPANY_ERROR"
